<script setup>
const props = defineProps({
  isText: {
    type: Boolean,
    default: false
  },
  isNoSystem: {
    type: Boolean,
    default: false
  }
})

const colorMode = useColorMode()
const isText = props.isText
const isShowNextModeLabel = ref(false)

const modes = ['system', 'light', 'dark', 'sepia']

const nextModeIcons = {
  system: '🖥️',
  light: '🌕',
  dark: '🌑',
  sepia: '🌒'
}

const nextMode = computed(() => {
  const currentModeIndex = modes.indexOf(colorMode.preference)
  const nextModeIndex = currentModeIndex+1 >= modes.length ? 0 : currentModeIndex+1

  return modes[nextModeIndex]
})

const nextModeIcon = computed(() => nextModeIcons[nextMode.value])

const toggleMode = () => colorMode.preference = nextMode.value

const actMouseEnter = () => {
  if (!isText) isShowNextModeLabel.value = true
}

const actMouseLeave = () => {
  if (!isText) isShowNextModeLabel.value = false
} 

</script>

<template>
  <div class="flex space-x-2 items-center">
    <span v-if="isShowNextModeLabel" class="text-gray-500 text-xs helptext">to {{ nextMode }}</span>
    <button 
      class="hover:bg-slate-800 hover:text-slate-200 dark:hover:bg-slate-200 dark:hover:text-slate-800 px-2 py-1 text-slate-800 text-base" 
      @click="toggleMode"
      @mouseenter="actMouseEnter"
      @mouseleave="actMouseLeave">
        {{ nextModeIcon }}<span v-if="isText" class="ml-2">switch to {{ nextMode }}</span>
    </button>
  </div>
</template>

<style scoped>
.helptext {
  position: absolute;
  transform: translateY(150%);
}
</style>